<template>
  <div v-if="planningTracker.number !== null">
    <p class="titleStyle grey">Inicio de planificación exitosa</p>
    <p class="titleStyle grey">Tu código de seguimiento es </p>
    <h1 style="text-align: center">{{planningTracker.number}}</h1>
    <hr>
    <p class="titleStyle green">Elige como quieres continuar:</p>
    <div class="buttonsContainer">
      <el-button
        class="btn primary"
        @click="rePlan()">
        Nueva Planificación
      </el-button>
      <el-button
        class="btn grey"
        @click="goToCheckState()">
        Estado de Planificación
      </el-button>
    </div>
  </div>
  <div v-else>
    <p class="titleStyle green">
      <i class="el-icon-loading" aria-hidden="true"></i>Comprobando configuraciónes de planificación
    </p>
  </div>
</template>

<script>

// import { apiRequest } from '../../backend/vue-axios/axios';

export default {
  props: {
    stepData: {
      type: Object,
    },
    planningTracker: {
      type: Object,
    },
  },
  data() {
    return {
      alias: '',
      totalSize: 0,
    };
  },
  methods: {
    rePlan() {
      this.$emit('returnPlan', 0);
    },
    goToCheckState() {
      this.$router.push('status');
    },
  },
};
</script>
<style lang="scss" scoped>
.buttonsContainer {
  margin-top: 2em;
}
.titleStyle {
  font-weight: 400;
  text-transform: uppercase;
  margin: 0;
  &.green {
    color: #AAD500;
    font-size: 0.8em;
  }
  &.grey {
    color: #9B9B9B;
    font-size: 1.5em;
  }
}
.subtitleStyle {
  color: #707070;
  font-size: 12px;
}
.el-icon-loading{
  color: #AAD500;
  font-size: 20px;
  margin-right: 10px;
}
</style>
